import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useWidgetStore = create(
  persist(
    (set) => ({
      activeWidgets: {
        calculator: false,
        notepad: false,
        dollar: false,
        weather: false,
      },
      positions: {
        calculator: { x: 80, y: 80, width: 300, height: 420 },
        notepad: { x: 400, y: 80, width: 340, height: 380 },
        dollar: { x: 80, y: 420, width: 280, height: 220 },
        weather: { x: 400, y: 420, width: 300, height: 260 },
      },
      zIndices: {
        calculator: 1000,
        notepad: 1000,
        dollar: 1000,
        weather: 1000,
      },
      maxZIndex: 1000,

      toggleWidget: (widgetName) =>
        set((state) => {
          const newActive = !state.activeWidgets[widgetName];
          const newMaxZ = state.maxZIndex + 1;
          return {
            activeWidgets: {
              ...state.activeWidgets,
              [widgetName]: newActive,
            },
            ...(newActive
              ? {
                  zIndices: {
                    ...state.zIndices,
                    [widgetName]: newMaxZ,
                  },
                  maxZIndex: newMaxZ,
                }
              : {}),
          };
        }),

      updatePosition: (widgetName, x, y, width, height) =>
        set((state) => ({
          positions: {
            ...state.positions,
            [widgetName]: {
              ...state.positions[widgetName],
              x,
              y,
              ...(width ? { width } : {}),
              ...(height ? { height } : {}),
            },
          },
        })),

      bringToFront: (widgetName) =>
        set((state) => {
          const newMaxZ = state.maxZIndex + 1;
          return {
            zIndices: {
              ...state.zIndices,
              [widgetName]: newMaxZ,
            },
            maxZIndex: newMaxZ,
          };
        }),
    }),
    {
      name: "whaticket-widgets-storage",
    }
  )
);
